import { useNavigate } from "react-router-dom";
import { SelectDocumentState } from "../../routing/RoutingStates";
import { ISelectProductRangeDescriptionProps } from "./SelectProductRangeInterfaces";
import { Row, Col } from "react-bootstrap";

export default function SelectProductRangeDescription({
  productRangeState,
}: ISelectProductRangeDescriptionProps) {
  const navigate = useNavigate();

  const viewList = () => {
    const selectDocumentState: SelectDocumentState = {
      basicMachineInformationResults: [],
      documentResults: [],
    };
    navigate("ViewDocuments", {
      state: { selectDocumentState },
    });
  };

  return (
    <Row className="padding-top">
      <Col xs={2}>
        <label>
          {productRangeState.isProductCompany
            ? "Product Company :"
            : "External Company :"}
        </label>
      </Col>
      <Col xs={4}>
        <label>
          {productRangeState.selectedCompany?.key}
          {productRangeState.selectedCompany?.label != "deselect" &&
            " / " + productRangeState.selectedCompany?.label}
        </label>
      </Col>
    </Row>
  );
}
